<template>
  <div class="bg_detail_container">
    <div v-if="bgcsTKName !== 'disShow'" class="title_bg">
      {{ bgcsTKName }}数据变更
    </div>
    <el-table
      border
      stripe
      :data="gridData"
      :row-style="{ height: 0 + 'px' }"
      :header-cell-style="{
        'text-align': 'center',
        background: '#F2F2F2',
        color: '#333',
      }"
      :cell-style="{ 'text-align': 'center' }"
      style="width: 100%; margin: auto"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        label="变更内容"
        prop="bgnr"
      />
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        label="变更时间"
        prop="cjsj"
      />
      <el-table-column align="ztLabel" prop="ztLabel" label="状态">
        <template slot-scope="scope">
          <!-- 13:已拒绝 12:同意 11:审批中 -->
          <span
            :style="
              scope.row.zt == '13'
                ? 'color:red '
                : scope.row.zt == '12'
                  ? 'color:#41b883'
                  : 'color:orange'
            "
          >{{ scope.row.ztLabel }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            style="border-radius: 20px !important"
            @click="ckDetail(scope.row)"
          >查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="margin-top: 30px"
      layout="prev,pager,next,jumper,total,sizes"
      :total="total"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="bg_list_obj.size"
      :current-page.sync="bg_list_obj.page"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
import { crkbgList, ykbbbgList, ysbbbgList } from '../../assets/js/bgcrk'
import bgxqCom from './bgxqCom.vue'
export default {
  components: { bgxqCom },
  props: ['curRowObj', 'curType', 'bgcsTKName'],
  data() {
    return {
      bg_list_obj: {
        page: 1,
        size: 10,
        param: {}
      },
      curRowMes: {},
      curRowType: '',
      total: 0, // 总条数
      gridData: [],
      dialogFormVisible: false,
      dgcsXqId: null // 详情弹框
    }
  },
  watch: {
    curRowObj: {
      handler(newName, oldName) {
        this.bgcsInfo(this.curRowObj, this.curType)
      },
      deep: true
    }
  },
  mounted() {
    const that = this
    setTimeout(() => {
      that.bgcsInfo(that.curRowObj, that.curType)
    }, 30)
  },
  methods: {
    // 当前页码改变时
    handleCurrentChange(val) {
      this.bg_list_obj.page = val // 当前页
      this.bgcsInfo(this.curRowMes, this.curRowType, this.bg_list_obj)
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.bg_list_obj.size = val // 当前页
      this.bgcsInfo(this.curRowMes, this.curRowType, this.bg_list_obj)
    },
    bgcsInfo(curRow, curType) {
      this.curRowMes = curRow
      this.curRowType = curType
      if (curType == 'ykbb') {
        ykbbbgList(curType, curRow.id, this.bg_list_obj).then((res) => {
          this.gridData = res.data.data.rows
          this.total = res.data.data.total
        })
      } else if (curType == 'ysbb') {
        ysbbbgList(curType, curRow.id, this.bg_list_obj).then((res) => {
          this.gridData = res.data.data.rows
          this.total = res.data.data.total
        })
      } else {
        crkbgList(curType, curRow.id, this.bg_list_obj).then((res) => {
          this.gridData = res.data.data.rows
          this.total = res.data.data.total
        })
      }
    },
    ckDetail(data) {
      this.$emit('bacsCkXqShow', data.id)
      // this.dgcsXqId = data.id;
      // this.dialogFormVisible = true;
    },
    // 关闭绑定气体标准弹窗
    handleCloseBindWarnStandard() {
      this.$emit('closeBindWarnStandard')
    }
  }
}
</script>

<style lang="less" scoped>
.bg_detail_container {
  width: 100%;
  .title_bg {
    margin-top: 30px;
    height: 30px;
    width: 100%;
    text-align: left;
    line-height: 30px;
    font-size: 20px;
    margin-bottom: 30px;
    text-align: center;
  }
}
</style>
